export default {
  data() {
    return {
      // 额外的参数
      tableExtraParams: {},
      // 表格数据常规参数
      tableParams: {
        pageIndex: 1,
        pageSize: 10
      },
      // 表格数据
      tableData: {
        totalPage: 1,
        totalCount: 1,
        list: []
      },
      createdLoad: true,
    };
  },
  created() {
    this.createdLoad && this.loadTableDataMixin(1)
  },
  methods: {
    async loadTableDataMixin(pageIndex = 1) {
      if (this.loadTableData) {
        const res = await this.loadTableData({
          ...this.tableParams,
          ...this.tableExtraParams,
          pageIndex
        });
        if (res.Code) {
          const { Success, Data, Msg } = res
          if (Success && Data) {
            this.tableData.totalPage = Data.totalPage || 1;
            this.tableData.totalCount = Data.totalCount || 10;
            this.tableData.pageIndex = pageIndex;
            this.tableParams.pageIndex = pageIndex;
            this.tableData.list =
              typeof Data.records === "undefined" ? (Array.isArray(Data) ? Data : Data.dataList || []) : Data.records;
          } else {
            this.$message.error(Msg || '获取数据异常')
          }
        } else if(res.code){
          const data = res.data || {}
          if (res.code.value === 2000000) {
            this.tableData.totalPage = data.pages || 1;
            this.tableData.totalCount = data.total || 10;
            this.tableData.pageIndex = pageIndex;
            this.tableParams.pageIndex = pageIndex;
            this.tableData.list = data.records || [];
          } else {
            this.$message.error(res.code.desc || '获取数据异常')
          }
        }
      }
    },
    handleTableSizeChange(size) {
      this.tableParams.pageSize = size;
      this.loadTableDataMixin(1);
    },
    handleTablePageChange(pageIndex) {
      this.loadTableDataMixin(pageIndex);
    },
    updateTaleExtraParams(params,reload = true) {
      this.tableExtraParams = params;
      this.loadTableDataMixin(reload ? 1 : this.tableParams.pageIndex)
    },
    async handleDeleteTableRow(row) {
      this.$confirm('确认要删除吗？',
        '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.confirmDeleteTableRow(row);
      });
    },
    async confirmDeleteTableRow(row) {
      if (!this.onDeleteRow) {
        console.warn('请实现删除回调！')
        return;
      }
      const { Success, code } = await this.onDeleteRow(row);
      if (Success || (code && code.value == 2000000)) {
        this.$message({
          message: "删除成功！",
          type: "success"
        });
        this.loadTableDataMixin(this.tableParams.pageIndex);
      }
      if (code && code.value != 2000000) {
        this.$message({
          message: code.desc,
          type: "error"
        });
      }
    }
  },
}


// WEBPACK FOOTER //
// ./src/mixins/table.js